import React from "react";
import { Col, Row, Breadcrumb } from '@themesberg/react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Routes } from "../../../routes";
import { ProductEditForm } from "../forms/catalog/productEditForm";

const ProductEdit = () => {
    const navigate = useNavigate();
    const { product_id } = useParams();

    const handleNavigate = () => {
        navigate(Routes.Catalog.path);
    };
    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0 mr-0">
                    <Breadcrumb
                        className="title-page"
                        listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
                    >
                        <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item>Toppo</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={() => handleNavigate()}>Catálogo</Breadcrumb.Item>
                        <Breadcrumb.Item active>Producto</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4 className="title-page">Edición del producto</h4>
                    <p className="mb-0">Aquí podrás ver la información del producto.</p>
                </div>
            </div>
            <Row>
                <Col xs={16} xl={16}>
                    <ProductEditForm orderId={product_id} />
                </Col>
            </Row>
        </>
    );
};

export default ProductEdit;
